/**
 *  @class
 *  @function MegaMenuSidebar
 */
if (!customElements.get('mega-menu-sidebar')) {
  class MegaMenuSidebar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.disconnectedCallback();
      this._listeners = new AbortController();
      const options = { signal: this._listeners.signal };
      this.buttons = this.querySelectorAll('.mega-menu-sidebar--button');
      this.content = this.querySelectorAll('.mega-menu-sidebar--content-inner');
      this.buttons.forEach((button, i) => {
        const activate = (event) => this.onHover(event, button, i);
        button.addEventListener('mouseover', activate, options);
        button.addEventListener('focus', activate, options);
        if (button.hasAttribute('data-panel-toggle')) {
          button.addEventListener('click', (event) => {
            event.preventDefault();
            activate(event);
          }, options);
          button.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ' || event.key === 'ArrowRight') {
              event.preventDefault();
              activate(event);
              const link = [...this.content[i].querySelectorAll('a[href]')].find((link) =>
                link.tabIndex >= 0 && !link.closest('[inert]') &&
                link.getClientRects().length > 0 && getComputedStyle(link).visibility === 'visible'
              );
              link?.focus();
            }
          }, options);
        }
      });
      this.submenu = this.closest('.sub-menu');
      this.menuItem = this.closest('.menu-item-has-children');
      this.trigger = this.menuItem?.querySelector(':scope > a');
      if (this.submenu && this.trigger) {
        const reopen = () => this.submenu.style.removeProperty('display');
        this.menuItem.addEventListener('mouseenter', reopen, options);
        this.menuItem.addEventListener('focusin', reopen, options);
        this.menuItem.addEventListener('focusout', (event) => {
          if (!this.menuItem.contains(event.relatedTarget)) reopen();
        }, options);
        this.menuItem.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            this.trigger.focus();
            // Override :focus-within/:hover until the next deliberate opening.
            this.submenu.style.display = 'none';
          } else if (event.target === this.trigger && event.key === 'ArrowDown') {
            event.preventDefault();
            reopen();
            this.buttons[0]?.focus();
          }
        }, options);
      }
      this.images = this.querySelectorAll('img');

      this._onLoad = () => {
        this.images.forEach(function (image) {
          lazySizes.loader.unveil(image);
        });
      };
      if (document.readyState === 'complete') this._onLoad();
      else window.addEventListener('load', this._onLoad, options);
    }

    disconnectedCallback() {
      this._listeners?.abort();
      this.submenu?.style.removeProperty('display');
      window.removeEventListener('load', this._onLoad);
    }

    onHover(event, button, i) {
      this.content.forEach((content, index) => {
        content.classList.remove('active');
        if (i == index) {
          content.classList.add('active');
        }
      });
      this.buttons.forEach((this_button, index) => {
        this_button.classList.remove('active');
        if (this_button.hasAttribute('data-panel-toggle')) {
          this_button.setAttribute('aria-expanded', String(i === index));
        }
      });
      button.classList.add('active');
    }
  }
  customElements.define('mega-menu-sidebar', MegaMenuSidebar);
}
